import {firestore} from 'firebase/app'
import {FirestoreQuery} from '../Firestore/FirestoreQuery'
import {FavoriteList} from './FavoriteList'
import {FavoriteListMapper} from './FavoriteListMapper'
import {IVendorPriceListEntry} from '../Order/OrderEntry/IVendorPriceListEntry'
import {v4 as uuid } from "uuid";

export class FavoriteListCollection {
  protected collection: string = 'favoriteList'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  watchFavoriteListsByRestaurant(
    companyId: string,
    cb?: (favoriteLists: FavoriteList[], unsub?: () => void) => void
  ): FavoriteList[] {
    const query = this.initQuery()
    query.setQuery(this.getFavoriteListsByRestaurantQuery(query, companyId))
    return query.watchList(cb)
  }

  list(): Promise<FavoriteList[]> {
    const query = this.initQuery()
    return query.list()
  }

  listFavoriteListsByRestaurant(restaurantCompanyId: string): Promise<FavoriteList[]> {
    const query = this.initQuery()
    query.setQuery(this.getFavoriteListsByRestaurantQuery(query, restaurantCompanyId))

    return query.list()
  }

  watch(id: string): { data: FavoriteList | null, unsub: () => void } {
    const query = this.initQuery()
    return query.watch(id)
  }

  async findFavoriteListByRestaurant(companyId: string): Promise<FavoriteList | null> {
    const query = this.initQuery()
    query.setQuery(
        query.collection(this.collection)
            .where('restaurantCompanyId', '==', companyId)
            .limit(1)
    )

    return ( await query.list() )[0]
  }

  get(id: string): Promise<FavoriteList | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  save(favoriteList: FavoriteList): Promise<FavoriteList> {
    // dedup entries
    const dedupedEntries = new Map<string, IVendorPriceListEntry>();
    favoriteList.entries.forEach(entry => {
      entry.description = entry.description.trim()
      const key = entry.description + entry.upc;
      const existingEntry = dedupedEntries.get(key);
      if (!existingEntry) {
        dedupedEntries.set(key, entry);
      }

      if(!entry.upc || entry.upc === '') {
        entry.upc = uuid()
      }
    })
    favoriteList.entries = [...dedupedEntries.values()];

    const query = this.initQuery()
    return query.save(favoriteList)
  }

  async delete(favoriteList: FavoriteList) {
    const query = this.initQuery();
    return query.delete(favoriteList)
  }

  protected initQuery(): FirestoreQuery<FavoriteList> {
    const query = new FirestoreQuery<FavoriteList>(this.db, new FavoriteListMapper())
    query.collection(this.collection)

    return query
  }

  protected getFavoriteListsByRestaurantQuery(query: FirestoreQuery<FavoriteList>, companyId: string) {
    return query.collection(this.collection)
      .where('restaurantCompanyId', '==', companyId)
  }
}
